export default {
    completa: "Complete your subscription payment",
    forma: "Payment method",
    tbk: "Transbank",
    tbkDesc: "Pay using Transbank",
    dLocal: "dLocal Go",
    dLocalDesc: "Pay using cards or cash with dLocal Go",
    handy: "International credit card",
    handyDesc: "Pay using an international credit card",
    auto: "Subscription with automatic renewal",
    stripe: "Stripe",
    stripeDesc: "Pay using Stripe",
    resumen: "Your subscription summary",
    diferencia: "You will be charged the difference to change your plan to: ",
    frecuencia: "Billing frequency: ",
    5: "(save 5%)",
    10: "(save 10%)",
    ingresarCupon: "Enter discount coupon",
    cupon: "Discount coupon",
    total: "Total",
    acuerdo: "By confirming I agree to the",
    terminos: "Terms of use",
    msgSeleccionarMetodo: "Select a payment method to continue",
    errorCupon: "Invalid coupon",
    mensual: "Monthly",
    semestral: "Semiannual",
    anual: "Annual",
    dtoAplicado: "Discount applied",
    elige: "Choose the plan that best suits you",
    mes: "/month",
    meses: "/6 months",
    año: "/year",
    incluye: "Includes: ",
    hasta: "Up to ",
    usuarios: " users",
    clientes: " clients",
    ordenes: " orders",
    sucursales: " branches",
    serv: "On-site services",
    graficos: "Statistical charts",
    appTecnico: "Android & iOS APP for technicians",
    appCliente: "Android APP for clients",
    web: "Web for client requests",
    wpp: "Whatsapp",
    api: "API",
    soporte: "Support response time",
    contratarPremium: "To subscribe to the Premium plan, please contact us",
    txtSubirPlan: "To use this feature, upgrade your plan",
    btnSubirPlan: "Upgrade plan"
}
